import { getColor } from "./getColor";
import { InvoiceIconType } from "./invoice.icon";

const BackgroundIcon = ({ active }: InvoiceIconType) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.11765 16.3654L0.257812 15.2929L4.04365 12.2588C4.65415 11.7949 5.46998 11.7995 6.04198 12.2597L9.0019 14.5523C9.0899 14.6192 9.21365 14.6164 9.29615 14.5495L14.1224 10.4649C14.7008 9.98086 15.5221 9.95702 16.1207 10.3998L18.9752 12.5384L18.1521 13.6393L15.3012 11.5034C15.2123 11.4374 15.0968 11.4448 15.007 11.5181L10.1807 15.6028C9.59865 16.0877 8.7489 16.1014 8.15765 15.6367L5.19131 13.3386C5.10148 13.268 4.9814 13.2744 4.89065 13.3432L1.11765 16.3654Z"
        fill={getColor(active)}
      />
      <path
        d="M17.6688 22H1.58125C0.708583 22 0 21.2914 0 20.4188V4.33125C0 3.45858 0.708583 2.75 1.58125 2.75H15.0233V4.125H1.58125C1.46575 4.125 1.375 4.21575 1.375 4.33125V20.4197C1.375 20.5352 1.46575 20.6259 1.58125 20.6259H17.6697C17.7852 20.6259 17.8759 20.5352 17.8759 20.4197V6.97675H19.25V20.4188C19.25 21.2914 18.5414 22 17.6688 22Z"
        fill={getColor(active)}
      />
      <path
        d="M18.3327 7.33333C16.3105 7.33333 14.666 5.68883 14.666 3.66667C14.666 1.6445 16.3105 0 18.3327 0C20.3548 0 21.9993 1.6445 21.9993 3.66667C21.9993 5.68883 20.3548 7.33333 18.3327 7.33333ZM18.3327 1.375C17.0686 1.375 16.041 2.40258 16.041 3.66667C16.041 4.93075 17.0686 5.95833 18.3327 5.95833C19.5968 5.95833 20.6243 4.93075 20.6243 3.66667C20.6243 2.40258 19.5968 1.375 18.3327 1.375Z"
        fill={getColor(active)}
      />
    </svg>
  );
};

export default BackgroundIcon;
